<template>
  <div class="recommend">
    <!--fix issue #2184-->
    <swiper :options="swiperOption">
      <swiper-slide class="most-news" v-for="item in mostNews" :key="item.id">
        <h3>最多点击</h3>
        <div class="recommend-title" @click="openNews(item.id)">{{ item.title }}</div>
        <div class="recommend-source">
          <span class="round"></span>
          <span class="source">来学网</span>
          <span class="update-time">{{ item.updated_at | formatTime('mm月dd日') }}</span>
        </div>
      </swiper-slide>
      <swiper-slide class="latest-news" v-for="item in lastestNews" :key="item.id">
        <h3>最新发布</h3>
        <div class="recommend-title" @click="openNews(item.id)">{{ item.title }}</div>
        <div class="recommend-source">
          <span class="round"></span>
          <span class="source">来学网</span>
          <span class="update-time">{{ item.updated_at | formatTime('mm月dd日') }}</span>
        </div>
      </swiper-slide>
    </swiper>
  </div>
</template>
<script>
import "swiper/dist/css/swiper.min.css";

export default {
  props: {
    mostNews: {
      type: Array,
      default: () => [],
    },
    lastestNews: {
      type: Array,
      default: () => [],
    },
    isShowHead: {
      type: Boolean,
      default: () => false,
    },
    categoryTitle: {
      type: String,
      default: () => '',
    },
  },

  data() {
    return {
      swiperOption: {
        slidesPerView: 'auto', // fix issue #2242
      },
    };
  },

  methods: {
    openNews(id) {
      let href = `/news/view.html?id=${id}&categoryTitle=${this.categoryTitle}`;
      if (this.isShowHead) {
        href += '&isShowHead=true';
      }
      window.location.href = href;
    }
  }
}
</script>
<style scoped>
  .recommend {
    padding-bottom: 50px;
  }

  .swiper-container {
    margin-left: 30px;
    padding: 20px 0 20px 26px;
  }

  .swiper-slide {
    margin-right: 20px;
    padding: 33px 26px 25px 20px;
    width: 364px!important;
    height: 299px;
    background: #fff;
    box-shadow: 0px 1px 20px 0px rgba(0, 0, 0, 0.14);
    border-radius: 10px;
    box-sizing: border-box;
  }

  h3 {
    margin-bottom: 30px;
    width: 138px;
    height: 50px;
    font-size: 24px;
    font-weight: 500;
    color: #fff;
    line-height: 50px;
    text-align: center;
  }

  .most-news h3 {
    background: linear-gradient(to right, #D05C53, #F04B4B);
    border-top-left-radius: 15px;
    border-bottom-right-radius: 15px;
  }

  .latest-news h3 {
    background: linear-gradient(to right, #53B2D0, #6B95EB);
    border-top-left-radius: 15px;
    border-bottom-right-radius: 15px;
  }

  .recommend-title {
    height: 80px;
    margin-bottom: 46px;
    font-size: 32px;
    color: #333;
    overflow: hidden;
    font-weight: 500;
    font-family: SourceHanSansCN-Medium;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }

  .recommend-source {
    width: 100%;
    height: 42px;
    clear: both;
  }

  .round {
    float: left;
    margin-right: 18px;
    width: 42px;
    height: 42px;
    border-radius: 100px;
  }

  .most-news .round {
    background: #A40000;
  }

  .latest-news .round {
    background: #00A0E9;
  }

  .source {
    margin-right: 5px;
    font-size: 28px;
    color: #333;
    vertical-align: super;
  }

  .update-time {
    font-size: 28px;
    color: #666;
    vertical-align: super;
  }
</style>
